// @ts-nocheck
// Import Calling Code font files using webpack's require syntax
import './CallingCode/bold.otf';
import './CallingCode/boldItalic.otf';
import './CallingCode/italic.otf';
import './CallingCode/regular.otf';

// Manrope is loaded via Google Fonts CDN in index.html

// Export a function to apply font styles
export function applyFontStyles() {
  const style = document.createElement('style');
  style.textContent = `
    @font-face {
      font-family: 'Calling Code';
      src: url('${require('./CallingCode/bold.otf')}') format('opentype');
      font-weight: 700;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'Calling Code';
      src: url('${require('./CallingCode/boldItalic.otf')}') format('opentype');
      font-weight: 700;
      font-style: italic;
      font-display: swap;
    }

    @font-face {
      font-family: 'Calling Code';
      src: url('${require('./CallingCode/italic.otf')}') format('opentype');
      font-weight: 400;
      font-style: italic;
      font-display: swap;
    }

    @font-face {
      font-family: 'Calling Code';
      src: url('${require('./CallingCode/regular.otf')}') format('opentype');
      font-weight: 400;
      font-style: normal;
      font-display: swap;
    }
  `;
  document.head.appendChild(style);
}
